import React from "react";
import PropTypes from "prop-types";

import Main from "src/app/components/Main/Main";
import Aside from "src/app/components/Aside/Aside";
import Card from "../../components/Card/Card";
import AsideSearch from "../../components/AsideSearch/AsideSearch";
import GetInTouch from "../../components/GetInTouch/GetInTouch";
import HelpTopics from "../../components/HelpTopics/HelpTopics";
import SearchList from "../../components/SearchList/SearchList";
import NoResultsSearchList from "../../components/NoResultsSearchList/NoResultsSearchList";
import ViewRelatedQuestions from "../../components/ViewRelatedQuestions/ViewRelatedQuestions";
import ErrorBox from "../../components/ErrorBox/ErrorBox";
import OrderSearchMessage from "src/app/components/OrderSearchMessage";

// eslint-disable-next-line no-unused-vars
import styles from "./SearchResults.module.css";

// eslint-disable-next-line complexity
const SearchResults = ({ content = {}, searchResults = {}, storeData }) => {
  const {
    body: {
      elements = [],
      "search-box": bodySearchBox,
      "popular-articles": popularArticles = [],
    } = {},
  } = content.main || {};
  const popularArticlesElements = popularArticles.elements || [];
  const {
    topics,
    "search-box": searchBox,
    "get-in-touch": getInTouch,
  } = content.aside || {};

  const isOrderSearch = searchResults?.orderNumberInQuery ?? false;
  const totalResults = searchResults?.results.length ?? 0;
  const hasResults = totalResults > 0;
  const placeholder =
    bodySearchBox?.elements[0]?.searchAgain?.["searchAgainHint-text"] ?? "";
  const searchHeaderTitle =
    bodySearchBox?.elements[0]?.yourSearchResultsFor?.[
      "yourSearchResultsFor-text"
    ] ?? "";

  let results;
  if (searchResults.error) {
    const {
      errorContent: [
        {
          searchApiErrorTitle = "Oops!",
          searchApiErrorDescription = "Sorry, this page isn’t available right now. In the meantime, why not take a look at another topic?",
        } = {},
      ] = [],
    } = content.main.body.elements[0];
    results = (
      <ErrorBox
        header={searchApiErrorTitle}
        description={searchApiErrorDescription}
        status={searchResults.error.status}
        errorType="Search API"
      />
    );
  } else if (searchResults.results && searchResults.results.length > 0) {
    results = (
      <SearchList
        items={searchResults.results}
        query={searchResults.query}
        currentPage={searchResults.currentPage}
        pageSize={searchResults.pageSize}
        start={searchResults.start}
        itemCount={searchResults.itemCount}
        storeData={storeData}
        searchListCopy={elements[0]}
        searchBox={bodySearchBox && bodySearchBox.elements[0]}
        baseUrl={content.metaData.baseUrl}
        isOrderSearch={isOrderSearch}
      />
    );
  } else {
    results = (
      <NoResultsSearchList
        noFaqsFound={elements[0] && elements[0].noFqsFound}
        placeholder={placeholder}
        searchHeaderTitle={searchHeaderTitle}
        query={searchResults.query}
      />
    );
  }

  const showSearchBox =
    searchBox && searchBox.elements && searchBox.elements.length > 0;
  const showGetInTouch =
    getInTouch && getInTouch.elements && getInTouch.elements.length > 0;
  const showTopic = topics && topics.elements && topics.elements.length > 0;

  return (
    <>
      <Main>
        <Card
          type="mainListingPage"
          ariaLive="polite"
          ariaRelevant="additions text"
        >
          {results}
          {!hasResults && isOrderSearch && <OrderSearchMessage />}
        </Card>
        {!(searchResults.results && searchResults.results.length) &&
          popularArticlesElements[0] &&
          popularArticlesElements[0].articles &&
          popularArticlesElements[0].articles.length > 0 && (
            <Card type="bottom" ariaLive="polite" ariaRelevant="additions text">
              <ViewRelatedQuestions
                data={popularArticlesElements[0]}
                button={popularArticlesElements[0]["faq-list"]}
                analytics={content.analytics}
              />
            </Card>
          )}
      </Main>
      <Aside>
        {showTopic && (
          <Card type="aside">
            <HelpTopics data={topics} />
          </Card>
        )}
        {showSearchBox && (
          <Card type="aside">
            <AsideSearch data={searchBox.elements[0]} />
          </Card>
        )}
        {showGetInTouch && (
          <Card type="aside">
            <GetInTouch data={getInTouch.elements[0]} />
          </Card>
        )}
      </Aside>
    </>
  );
};

SearchResults.defaultName = "SearchResults";

export default SearchResults;

SearchResults.propTypes = {
  content: PropTypes.object,
  searchResults: PropTypes.object,
  storeData: PropTypes.object,
};
